import { GroupSecurity } from '@quromedical/fhir-common';
import { WithGroup } from 'core/auth';
import { ChatRoomCard } from 'core/chat';
import React from 'react';

interface NextOfKinChatTabProps {
  patientId: string;
  nextOfKinId: string;
}

export const NextOfKinChatTab: React.FC<NextOfKinChatTabProps> = ({ patientId, nextOfKinId }) => {
  return (
    <WithGroup groups={[GroupSecurity.CommunicationCreate]}>
      <ChatRoomCard patientId={patientId} nextOfKinId={nextOfKinId} key={nextOfKinId} />
    </WithGroup>
  );
};
